import React from "react"
const headerStyle = {
	color: "#3080ed",
}

export default function Header({ children }) {
	return <h1 style={headerStyle}>{children}</h1>
}
